import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NSNotFoundPage } from "namirasoft-site-react";
import { NamirasoftTelegramSenderServer } from "namirasoft-telegram-sender";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { TelegramSenderLayout } from "./TelegramSenderLayout";
import { TelegramSenderRoutes } from "./TelegramSenderRoutes";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import ProviderEditPage from "./pages/ProviderEditPage";
import ProviderListPage from "./pages/ProviderListPage";
import ProviderViewPage from "./pages/ProviderViewPage";
import SendPage from "./pages/SendPage";
import SentListPage from "./pages/SentListPage";
import VerifyBotPage from "./pages/VerifyBotPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_TELEGRAM_SENDER}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_TELEGRAM_SENDER = new EnvService("REACT_APP_BASE_URL_TELEGRAM_SENDER", true).getString();

            let telegram_sender = new NamirasoftTelegramSenderServer(REACT_APP_BASE_URL_TELEGRAM_SENDER, result.account.token_manager, result.notifier.onError);

            let servers = { telegram_sender };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={TelegramSenderRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={TelegramSenderRoutes.ProviderList} element={<ProviderListPage {...result} servers={servers} />} />
                            <Route path={TelegramSenderRoutes.ProviderNew} element={<ProviderEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={TelegramSenderRoutes.ProviderCopy(":id")} element={<ProviderEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={TelegramSenderRoutes.ProviderEdit(":id")} element={<ProviderEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={TelegramSenderRoutes.ProviderView(":id")} element={<ProviderViewPage {...result} servers={servers} />} />

                            <Route path={TelegramSenderRoutes.SentList} element={<SentListPage {...result} servers={servers} />} />

                            <Route path={TelegramSenderRoutes.Send(null)} element={<SendPage {...result} servers={servers} />} />
                            <Route path={TelegramSenderRoutes.Send(":id")} element={<SendPage {...result} servers={servers} />} />

                            <Route path={TelegramSenderRoutes.Verify(":provider_id")} element={<VerifyBotPage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={TelegramSenderRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <TelegramSenderLayout {...props}>
                {props.children}
            </TelegramSenderLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;